import { Injectable } from '@angular/core';
import { Firestore, collection, doc, setDoc, updateDoc, collectionData, docData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Bid } from '../models/bid.interface';
import { Msg } from '../models/msg.interface';
import { User } from "../models/user.interface";

@Injectable({
  providedIn: 'root'
})
export class BidService {
  currentBidPairId: any;
  currentBidPartner: any;

  constructor(private firestore: Firestore) {}

  addBid(id: string, msg: Msg) {
    const bidRef = doc(this.firestore, 'ge_bids', id);
    const bidsCollectionRef = collection(bidRef, 'bids');
    const newDocRef = doc(bidsCollectionRef);
    return setDoc(newDocRef, msg);
  }

  createBid(id: string, bid: Bid) {
    const bidRef = doc(this.firestore, 'ge_bids', id);
    return setDoc(bidRef, bid, { merge: true });
  }

  updateBid(id: string, bid: Bid) {
    const bidRef = doc(this.firestore, 'ge_bids', id);
    return updateDoc(bidRef, { ...bid });
  }

  updateCurrent(id: string, msg: Msg) {
    const bidRef = doc(this.firestore, 'ge_bids', id);
    return setDoc(bidRef, msg, { merge: true });
  }

  getCurrent(customer: string, gig: string, provider: string): Observable<Bid | undefined> {
    const pairId = `${customer}${gig}${provider}`;
    const bidRef = doc(this.firestore, 'ge_bids', pairId);
    return docData(bidRef) as Observable<Bid>;
  }

  getInvites(provider: string): Observable<Bid[]> {
    const bidsCollectionRef = collection(this.firestore, 'ge_users', provider, 'bids');
    return collectionData(bidsCollectionRef) as Observable<Bid[]>;
  }

  createPairId(customer: string, gig: string, provider: string): string {
    return `${customer}${gig}${provider}`;
  }
}
